import axios from 'axios'
import { url } from '../../api/url'
import { HeadersWithCredentials } from '../../api/header'

export const GetOrganisationSettings = async (userId) => {
    return await axios.get(`${url}/user/organisation-settings/${userId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const getCurrentUser = async () => {
    return await axios.get(`${url}/user/findOne`, {
        headers: HeadersWithCredentials(),
    })
}

export const getUserCompetitionsInfo = async (params = {}) => {
    return await axios.get(`${url}/user/competitions-info`, {
        headers: HeadersWithCredentials(),
        params,
    })
}

export const getMyAccountUserCompetitions = async (params = {}) => {
    return await axios.get(`${url}/user/my-account-competitions`, {
        headers: HeadersWithCredentials(),
        params,
    })
}

export const userUpdate = async (userId, body) => {
    return await axios.put(`${url}/user/update/${userId}`, body, {
        headers: HeadersWithCredentials(),
    })
}

export const getOrganisations = async (page, limit, searchTerm) => {
    return await axios.get(`${url}/user/organisations/${page}/${limit}`, {
        params: { searchTerm },
        headers: HeadersWithCredentials(),
    })
}

export const getUserGalary = async () => {
    return await axios.get(`${url}/user/galary`, {
        headers: HeadersWithCredentials(),
    })
}

export const getGalaryByParticipation = async (usersIds, wodId, participationId) => {
    return await axios.get(`${url}/user/galary-by-participation`, {
        headers: HeadersWithCredentials(),
        params: { usersIds, wodId, participationId },
    })
}

export const getGalaryByDivision = async (competitionId, divisionId) => {
    return await axios.get(`${url}/user/galary-by-division/${competitionId}/${divisionId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const deleteFromUserGalary = async (fileId) => {
    return await axios.delete(`${url}/user/galary/${fileId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const uploadToUserCover = async (userId, target, data) => {
    return await axios.put(`${url}/user/upload-to-user-cover/${userId}/${target}`, data, {
        headers: HeadersWithCredentials(),
    })
}

export const getUserComplaints = async (competitionId) => {
    return await axios.get(`${url}/user/complaints/${competitionId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const hasCompetitions = async () => {
    return await axios.get(`${url}/user/has-competitions`, {
        headers: HeadersWithCredentials(),
    })
}

export const uploadToGalary = async (competitionId, divisionId, wodId, participationId, body) => {
    return await axios.put(
        `${url}/user/galary/upload/${competitionId}/${divisionId}/${wodId}/${participationId}`,
        data,
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const updateAccountCategory = async (userId, category) => {
    return await axios.put(
        `${url}/user/update-account-category/${userId}`,
        { category },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const searchUsers = async (searchTerm) =>
    await axios.get(`${url}/user/search-users?searchTerm=${searchTerm}`, {
        headers: HeadersWithCredentials(),
    })

export const getBannedUsers = async () =>
    await axios.get(`${url}/user/banned-users`, {
        headers: HeadersWithCredentials(),
    })

export const toggleBanned = async (userId, banned) =>
    await axios.put(
        `${url}/user/toggle-banned/${userId}`,
        { banned },
        {
            headers: HeadersWithCredentials(),
        },
    )

export const getUsers = async (params) =>
    await axios.get(`${url}/user`, {
        params,
        headers: HeadersWithCredentials(),
    })

export const toggleDeleteUserInfo = async (userId) =>
    await axios.put(
        `${url}/user/toggle-delete-info/${userId}`,
        {},
        {
            headers: HeadersWithCredentials(),
        },
    )
